const newArea = {
  snackbar: "Ihr Update ist fertig",
  name: "Name der Klassifizierung für explosionsgefährdete Bereiche",
  save: "speichern",
  cancel: "Stornieren",
  area: "Gefahrenbereichsklassifizierung",
  formTitle: "Neue Gefahrenbereichsklassifizierung",
  confirm: "Möchten Sie diesen Artikel wirklich löschen?",
  close: "Schließen",
  delete: "Löschen"
};
export default newArea;
